module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAMAAABo+94fAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUdwTP///////////////////////////////////////////////////////////////////////////////////////////////9JyxnAAAAAYdFJOUwB6jBM4x/QL051M6yoF4hv5t6xawkhraTMEhFYAAACaSURBVBjTZZBZDsQgDEPNvhToPpP7n3RoC6Vl/BPpKXJiAwa3wqLJfoE9AJusVGo6tCUbYUj7gi1d0pxB5MlPo0BVVgApz4GNgK80ZYpP2XCuYpWpYIo6zRnHqafEj0vuD5+fCdtRfQUc3dvHXSnW9/I0lnTLC7PaRWTD47vYqpPpjlIKNSascztXa94f/1mPhwNX2XtQXDb2A7YkFaleE0nVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/twitter_0609.png
// module id = 1816
// module chunks = 5